import { TranslateLoader } from "@ngx-translate/core";
import { from, Observable } from "rxjs";

/*
 * The translations come with the build rather than over http (#183). Each
 * file becomes a chunk of its own with a hash of its content in its name, as
 * the code does. Fetched as assets/i18n/nl.json, a browser could keep an old
 * copy for days next to new code, which then showed its keys rather than
 * text - on acceptance until a hard reload.
 */
const translations: Record<string, () => Promise<{ default: object }>> = {
  nl: () => import("../../../public/assets/i18n/nl.json"),
  en: () => import("../../../public/assets/i18n/en.json"),
};

export class BundledTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<object> {
    const load = translations[lang] ?? translations["nl"];

    return from(load().then((file) => file.default));
  }
}
